import { Item } from '../items/items.entity';
import { PaymentMethodImage } from '../payment/payment.entity';
import { PaymentTabs } from '../payment/payment.entity';

export type WithdrawalTab = {
	title: string,
	name: PaymentTabs,
	img: string,
	key: string,
	provider: string,
  }
  

export type WithdrawalTokens = {
	[key: string]: WithdrawalToken;
  };

export type WithdrawalToken = {
	icon: PaymentMethodImage;
	networks: NetworkItem[];
	tokenName: string;
};

export type NetworkItem = {
	id: number;
	fullSystemCode: string;
	isSupportExtra: boolean;
	networkFee: string;
	networkInformer: string;
	networkName: string;
	rate: string;
}

export type WithdrawalMethod = {
  id: number;
  name: string;
  provider: string;
  icon: WithdrawalMethodIcon|null;
  minAmountOnAccountToShow: number;
  minAmount: number;
  maxAmount: number;
  feePct: string;
  key: string|null;
};

export type Withdrawal = {
	id: number;
	amount: number;
	status: WithdrawalStatus;
	method: WithdrawalMethod;
	context: WithdrawalContext;
	result: WithdrawalResult|null;
	createdAt: string;
	errorText: string|null;
	canCancel: boolean;
	tokenInfo: WithdrawalCryptoToken|null;
};

export type WithdrawalCryptoToken = {
	networkInformer: string;
	icon: WithdrawalMethodIcon;
  };

export type WithdrawalMethodIcon = {
  fileName: string;
};

export enum WithdrawalStatus {
	CREATED = 1,
	ON_HOLD = 2,
	PROCESSING = 3,
	DONE = 4,
	REFUNDED = 5
}

export type WithdrawalContext = SteamWithdrawalContext |
                         Standoff2WithdrawalContext |
                         MoneyWithdrawalContext |
						LisSkinsWithdrawalContext | 
						CryptoWithdrawalContext;

export type SteamWithdrawalContext = {
	itemId: number;
	item: Item;
	partner: string;
	token: string;	
};

export type Standoff2WithdrawalContext = {
	avatarUrl: string;
	skinToPlace: string;
};

export type MoneyWithdrawalContext = {
	wallet: string;
};

export type CryptoWithdrawalContext = {
    tokenId: number;
    address: string;
    extra: string|null;
};

export type GGPayWithdrawalContext = {};

export type HorizonWithdrawalContext = {};

export type LisSkinsWithdrawalContext = {};

type WithdrawalResult = SteamWithdrawalResult|MoneyWithdrawalResult;

export type SteamWithdrawalResult = {
	status: SteamWithdrawalStatus;
  tradeId: number|null;
  timeoutAt: string;
};

export const enum SteamWithdrawalStatus {
	WAITING_SELLER = 1,
	SENT = 2,
	CANCELLED = 3,
	TIMEOUT = 4
}

type MoneyWithdrawalResult = void;

export type PreferredWallet = {
	id: number;
	wallet: string;
	method: Pick<WithdrawalMethod, 'id'>;
	createdAt: string;
};

export namespace ApiResponse {
  export interface Withdrawals {
		needPlayGames: number;
    withdrawals: Withdrawal[];
  }

  export interface Methods {
    methods: WithdrawalMethod[];
		preferredWallets: PreferredWallet[];
  }

	export interface CreatedWithdrawal {
		withdrawal: Withdrawal;
		preferredWallet: PreferredWallet;
	}

	export interface SkinToWithdraw {
    item: Item|null;
  }

  export interface Tokens {
    tokens: WithdrawalTokens;
  }
}